/* Styled at Suttles: look slideshows and the homepage looks row */
(function () {
  function initMedia(root) {
    if (root.dataset.slReady) return;
    root.dataset.slReady = '1';
    var track = root.querySelector('[data-sl-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sl-dot]'));
    var visible = false;
    var timer;

    function current() {
      return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function update() {
      var c = current();
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === c ? 'true' : 'false');
      });
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === c && visible) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    var prev = root.querySelector('[data-sl-prev]');
    var next = root.querySelector('[data-sl-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(update, 80);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          update();
        });
      }, { threshold: 0.4 }).observe(root);
    } else {
      visible = true;
    }
    update();
  }

  function initRow(row) {
    if (row.dataset.slReady) return;
    row.dataset.slReady = '1';
    var track = row.querySelector('[data-sl-row-track]');
    var prev = row.querySelector('[data-sl-row-prev]');
    var next = row.querySelector('[data-sl-row-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      row.classList.toggle('sl-row--scrollable', max > 4);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-sl-media]').forEach(initMedia);
    document.querySelectorAll('[data-sl-row]').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
